import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastProvider } from './context/ToastContext';

import LoginPage from './pages/LoginPage';
import VerificationCodePage from './pages/VerificationCodePage';
import SignupBusinessPage from './pages/SignupBusinessPage';
import ConfirmUser from './pages/ConfirmUser';
import ResetPasswordPage from './pages/ResetPassword';
import Scaffold from './components/layout/Scaffold';
import MainDashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import BranchManagement from './pages/BranchManagement';
import StaffToStore from './pages/StaffToStore';
import DiscountManager from './pages/DiscountManager';
import CreateStore from './pages/CreateStore';
import EditStore from './pages/EditStore';
import StoreDetails from './pages/StoreDetails';
import CustomerReturns from './pages/CustomerReturns';
import CreateStoreTaxes from './pages/CreateStoreTaxes';
import ProductCatalogs from './pages/ProductCatalogs';
import ItemDetails from './pages/ItemDetails';
import CreateCatalogs from './pages/CreateCatalogs';
import CreateCategories from './pages/CreateCategories';
import CreateProductItem from './pages/CreateProductItem';
import EditProductItem from './pages/EditProductItem';
import CreatePackageItem from './pages/CreatePackageItem';
import ViewCatentryDetails from './pages/ViewCatentryDetails';
import NewAccounting from './pages/NewAccounting';
import NewAccount from './pages/NewAccount';
import NewJournalEntry from './pages/NewJournalEntry';
import AccountType from './pages/AccountType';
import MappingManager from './pages/MappingManager';
import AccountDetailsPage from './pages/AccountDetails';
import AccountLedgerPage from './pages/AccountLedgerPage';
import EditAccount from './pages/EditAccount';
import OrderDetails from './pages/OrderDetails';
import TransactionCorrectionManager from './pages/TransactionCorrectionManager';
import ExpenseLogging from './pages/Expenses';
import PointOfSale from './pages/PointOfSale';
import CustomerManagement from './pages/CustomerManagement';
import GroupMemberManager from './pages/GroupMemberManager';
import Invoices from './pages/Invoices';
import Receipts from './pages/Receipts';
import PaymentsReceived from './pages/PaymentsReceived';
import InvoiceDetails from './pages/InvoiceDetails';
import ReceiptDetails from './pages/ReceiptDetails';
import Creditline from './pages/Creditline';
import NewCustomerDetails from './pages/NewCustomerDetails';
import NewInvoice from './pages/NewInvoice';
import NewCreditNote from './pages/NewCreditNote';
import ReceivePayment from './pages/ReceivePayment';
import NewReceipt from './pages/NewReceipt';
import ImportData from './pages/ImportData';
import CreateRoles from './pages/CreateRoles';
import GoodsReceiptApproval from './pages/GoodsReceiptApproval';
import FastTrackRestock from './pages/FastTrackRestock';
import ReturnToVendor from './pages/ReturnToVendor';
import EditVendorGoodsReceiptWithoutPayment from './pages/EditVendorGoodsReceiptWithoutPayment';
import VendorGoodsReceiptWithoutPayment from './pages/VendorGoodsReceiptWithoutPayment';
import VendorPurchaseOrders from './pages/VendorPurchaseOrders';
import PurchaseOrderManagement from './pages/PurchaseOrderManagement';
import VendorManagement from './pages/VendorManagement';
import InventoryLots from './pages/InventoryLot';
import Inventory from './pages/Inventory';
import InventoryTransferManager from './pages/InventoryTransferManager';
import Users from './pages/Users';
import UserProfile from './pages/UserProfile';
import NewCustomer from './pages/NewCustomer';
import NewStaffMember from './pages/NewStaffMember';
import AccountingReports from './pages/AccountingReports';
import LedgerSummaryReport from './pages/LedgerSummaryReport';
import NewTrialBalanceReport from './pages/NewTrialBalance';
import VendorSubledgerReport from './pages/VendorSubledgerReport';
import GeneralJournalReport from './pages/GeneralJournalReport';
import CustomerList from './pages/CustomerList';
import CustomerLedgerReport from './pages/CustomerLedgerReport';
import ReportTemplate from './pages/ReportTemplate';
import StockHistory from './pages/StockHistory';
import EndOfDaySalesReport from './pages/EndOfDaySalesReport';
import SalesPerformanceReport from './pages/SalesPerformanceReport';
import AccountLedgerReport from './pages/AccountLedgerReport';
import InventoryValuationDashboard from './pages/InventoryValuationDashboard';
import GoodsReceiptHistory from './pages/GoodsReceiptHistory';
import ExpenseReport from './pages/ExpenseReport';
import SalesReport from './pages/SalesReport';
import NewStockHistory from './pages/NewStockHistory';
import NewPNLReport from './pages/NewPNLReport';
import InventoryClosingReport from './pages/InventoryClosingReport';
import CreateProductionOrder from "./pages/CreateProductionOrder";
import ConfigureProductSpecs from "./pages/ConfigureProductSpecs";
import ManufacturingDashboard from "./pages/ManufacturingDashboard";
import FixedAssetsDashboard from "./pages/FixedAssetsDashboard";
import ProductionOrderFlowManager from "./pages/ProductionOrderFlowManger";
import EmployeeProfilesManager from "./pages/EmployeeProfilesManager";
import SeerbitPocketManager from "./pages/SeerbitPocketManager";
import PayrollMakerManager from "./pages/PayrollMakerManager";
import PayrollCheckerManager from "./pages/PayrollCheckerManager";
import WalletExpenses from "./pages/WalletExpenses";
import StoreAccountMapping from "./pages/StoreAccountMapping";
import EditInvoice from "./pages/EditInvoice";
import NewRFQ from "./pages/NewRFQ";
import RfqDashboard from "./pages/RFQDashboard";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";


function App() {
	return (
		<Router>
			<ToastProvider>
				<Routes>
					<Route path="/" element={<LoginPage />} />
					<Route path="/login" element={<LoginPage />} />
					<Route path="/login-verification" element={<VerificationCodePage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password/:salt" element={<ResetPasswordPage />} />
					<Route path="/change-password/:salt" element={<ResetPasswordPage />} />
					<Route path="/signup-business" element={<SignupBusinessPage />} />
					<Route path="/confirmuser/:salt" element={<ConfirmUser />} />
					<Route path="/*" element={<Scaffold />}>
                        <Route path="dashboard">
                            {/* <Route index element={<InventoryAnalytics />} /> */}
                            <Route index element={<MainDashboard />} />
                        </Route>
                        <Route path="chat">
                            <Route index element={<Chat />} />
                        </Route>
                        <Route path="branches">
                            {/* <Route index element={<Stores />} /> */}
                            <Route index element={<BranchManagement />} />
                            <Route path="staff-to-branch" element={<StaffToStore />} />
                            <Route path="manage-discount" element={<DiscountManager />} />
                            <Route path="create" element={<CreateStore />} />
                            <Route path="edit" element={<EditStore />} />
                            <Route path="details" element={<StoreDetails />} />
                            <Route path="customer-return" element={<CustomerReturns />} />
                            <Route path="spec-branch-tax" element={<CreateStoreTaxes />} />
                        </Route>
                        <Route path="catalog">
                            <Route index element={<ProductCatalogs />} />
                            <Route path="item-details" element={<ItemDetails />} />
                            <Route path="create-catalogs" element={<CreateCatalogs />} />
                            <Route path="create-categories" element={<CreateCategories />} />
                            <Route path="create-item" element={<CreateProductItem />} />
                            <Route path="edit-item" element={<EditProductItem />} />
                            <Route path="create-package" element={<CreatePackageItem />} />
                            <Route path="view-details" element={<ViewCatentryDetails />} />
                        </Route>
                        <Route path="accounting">
                            <Route index element={<NewAccounting />} />
                            <Route path="coa" element={<NewAccounting />} />
                            <Route path="new-account" element={<NewAccount />} />
                            <Route path="store-account-mapping" element={<StoreAccountMapping />} />
                            <Route path="new-journal-entry" element={<NewJournalEntry />} />
                            <Route path="accounttype" element={<AccountType />} />
                            <Route path="mapping-manager" element={<MappingManager />} />
                            <Route path="details" element={<AccountDetailsPage />} />
                            <Route path="ledger" element={<AccountLedgerPage />} />
                            <Route path="edit" element={<EditAccount />} />
                            <Route path="order-details" element={<OrderDetails />} />
                            <Route path="transactions" element={<TransactionCorrectionManager />} />
                            <Route path="expenses" element={<ExpenseLogging />} />
                            <Route path="assets" element={<FixedAssetsDashboard />} />
                        </Route>
                        <Route path="wallet">
                            <Route index element={<SeerbitPocketManager />} />
                            <Route path="virtual-wallet" element={<SeerbitPocketManager />} />
                            <Route path="payroll-management" element={<EmployeeProfilesManager />} />
                            <Route path="payroll-maker" element={<PayrollMakerManager />} />
                            <Route path="payroll-checker" element={<PayrollCheckerManager />} />
                            <Route path="wallet-expenses" element={<WalletExpenses />} />
                        </Route>
                        <Route path="jobs">
                            <Route index element={<ProductionOrderFlowManager />} />
                            <Route path="all-jobs" element={<ProductionOrderFlowManager />} />
                            <Route path="new-workflow" element={<ManufacturingDashboard />} />
                            {/* <Route path="blueprint-and-specs" element={<ProductSpecsManager />} />
                            <Route path="production-order-scheduler" element={<ProductionOrderScheduler />} />
                            <Route path="in-process-console" element={<ProductionFloorConsole />} />
                            <Route path="issue-raw-materials" element={<MaterialConsumptionStation />} /> */}

                            {/* <Route path="configure-production-route" element={<ConfigureProductSpecs />} />
                            <Route path="create-production-order" element={<CreateProductionOrder />} /> */}
                        </Route>
                        <Route path="sales">
                            <Route index element={<PointOfSale />} />
                            <Route path="pos" element={<PointOfSale />} />
                            {/* <Route path="customers" element={<CustomerList />} /> */}
                            <Route path="customers" element={<CustomerManagement />} />
                            <Route path="group/members" element={<GroupMemberManager />} />
                            <Route path="discounts" element={<DiscountManager />} />

                            <Route path="invoices" element={<Invoices />} />
                            <Route path="invoices/new" element={<NewInvoice />} />

                            <Route path="receipts" element={<Receipts />} />
                            {/* <Route path="returns" element={<CustomerReturns />} /> */}

                            <Route path="quotation" element={<RfqDashboard />} />
                            <Route path="quotation/new" element={<NewRFQ />} />

                            <Route path="payments" element={<PaymentsReceived />} />
                            <Route path="invoices/view" element={<InvoiceDetails />} />
                            <Route path="invoices/edit/:ordersId" element={<EditInvoice />} />
                            <Route path="receipts/view" element={<ReceiptDetails />} />
                            <Route path="customers/line-of-credit" element={<Creditline />} />
                            <Route path="customers/new" element={<NewCustomerDetails />} />
                            <Route path="credit-notes/new" element={<NewCreditNote />} />
                            <Route path="invoices/receive-payment" element={<ReceivePayment />} />
                            <Route path="receipts/new" element={<NewReceipt />} />
                        </Route>
                        <Route path="import-data" element={<ImportData />} />
                        <Route path="roles">
                            <Route index element={
                                <div className="flex items-center justify-center h-full"> <h2 className="text-gmail-green text-3xl font-bold p-4">Roles List Page Placeholder</h2> </div>
                            } />
                            <Route path="create" element={<CreateRoles />} /> {/* New Create Roles Page route */}
                        </Route>
                        <Route path="vendor">
                            <Route index element={<VendorManagement />} />
                            <Route path="list" element={<VendorManagement />} />
                            <Route path="create-purchase-orders" element={<PurchaseOrderManagement />} />
                            <Route path="view-purchase-orders" element={<VendorPurchaseOrders />} />
                            <Route path="vendor-goods-receipt" element={<VendorGoodsReceiptWithoutPayment />} />
                            <Route path="edit-vendor-goods-receipt" element={<EditVendorGoodsReceiptWithoutPayment />} />
                            <Route path="return-to-vendor" element={<ReturnToVendor />} />
                            <Route path="fast-restock" element={<FastTrackRestock />} />
                            <Route path="approve-vendor-goods-receipt" element={<GoodsReceiptApproval />} />
                        </Route>
                        <Route path="inventory">
                            <Route index element={<Inventory />} />
                            <Route path="index" element={<Inventory />} />
                            <Route path="inventory-transfer" element={<InventoryTransferManager />} />
                            <Route path="lots" element={<InventoryLots />} />
                        </Route>
                        <Route path="settings">
                            <Route index element={<Users />} />
                            <Route path="user-profile" element={<UserProfile />} />
                            <Route path="new-customer" element={<NewCustomer />} />
                            <Route path="invite-staff" element={<NewStaffMember />} /> {/* New Invite Staff Page route */}
                        </Route>
                        <Route path="reports">
                            <Route index element={<AccountingReports />} />
                            <Route path="general-ledger-report" element={<LedgerSummaryReport />} />
                            <Route path="general-ledger-trial-balance" element={<NewTrialBalanceReport />} />
                            <Route path="vendor-ledger-report" element={<VendorSubledgerReport />} />
                            <Route path="general-journal-report" element={<GeneralJournalReport />} />
                            <Route path="customer-list" element={<CustomerManagement />} />
                            <Route path="customer-report" element={<CustomerLedgerReport />} />
                            <Route path="report-template" element={<ReportTemplate />} />
                            <Route path="stock-history" element={<StockHistory />} />
                            <Route path="eod-sales-report" element={<EndOfDaySalesReport />} />
                            <Route path="sales-performance" element={<SalesPerformanceReport />} />
                            <Route path="account-ledger-report" element={<AccountLedgerReport />} />
                            <Route path="inventory-valuation-report" element={<InventoryValuationDashboard />} />
                            <Route path="goods-receipt-history" element={<GoodsReceiptHistory />} />
                            <Route path="expense-report" element={<ExpenseReport />} />
                            <Route path="sales-report" element={<SalesReport />} />
                            <Route path="new-stock-history" element={<NewStockHistory />} />
                            <Route path="profit-and-loss" element={<NewPNLReport />} />
                            <Route path="inventory-closing-report" element={<InventoryClosingReport />} />
                        </Route>
					</Route>
				</Routes>
			</ToastProvider>
		</Router>
	)
}

// 

export default App